export const imagingOptions = [
  { label: "X-Ray Chest", value: "xray_chest" },
  { label: "CT Scan Head", value: "ct_head" },
  { label: "MRI Brain", value: "mri_brain" },
  { label: "Ultrasound Abdomen", value: "ultrasound_abdomen" },
  { label: "Echocardiogram", value: "echocardiogram" },
  { label: "Mammography", value: "mammography" },
  { label: "Bone Density Scan", value: "bone_density" },
  { label: "PET Scan", value: "pet_scan" },
];
